import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  getAverageSale,
  getLeaderboardProductivity,
  getPercentageThatIncludeAtLeastOneProduct,
  getProductSales,
  getNewCustomers,
  getServiceSales,
} from '../selectors';
import * as barberSelectors from '../../../barbers/selector';
import Leaderboard from '../components/Leaderboard';

const LeaderboardContainer = compose(
  connect(
    (state) => {
      const getBarberById = barberSelectors.getById.bind(null, state);
      return {
        serviceSales: getServiceSales(state, getBarberById),
        productSales: getProductSales(state, getBarberById),
        productivity: getLeaderboardProductivity(state, getBarberById),
        averageSale: getAverageSale(state, getBarberById),
        newCustomers: getNewCustomers(state, getBarberById),
        percentageThatIncludeAtLeastOneProduct: getPercentageThatIncludeAtLeastOneProduct(state, getBarberById),
      };
    }
  )
)(Leaderboard);

export default LeaderboardContainer;
